const { appendToUrl } = require('../utils/urlUtil');
const waiNotify = require('../components/waiNotify');

const selectors = {
    body: 'body',
    cartErrorAvailability: '.js-product_cart-error_availability',
    productAvailability: '.js-product_availability',
    productAvailabilityError: '.js-product_availability-error'
};

/*
 * Display Availability error for the current element
 */
function toggleAvailabilityError(element, isError) {
    const $inputElement = $(element);
    const $productInfo = $inputElement.closest('.js-product-info');
    const $productAvailability = $productInfo.find(selectors.productAvailability);
    const uuid = $productAvailability.data('uuid');
    const $errorContainer = $productInfo.find(`.js-availability-short-${uuid}`);

    if (isError) {
        if ($errorContainer.length > 0 && $errorContainer.html().trim() === '') {
            $errorContainer.append($inputElement.data('error-message'));
        }
    } else if ($errorContainer.length > 0) {
        $errorContainer.empty();
    }
}

/*
 * Check Availability
 */
function checkAvailability() {
    const $body = $(selectors.body);

    $body.find(selectors.cartErrorAvailability).each(function() {
        var $productAvailability = $(this).find(selectors.productAvailability),
            $productAvailabilityError = $productAvailability.find(selectors.productAvailabilityError),
            uuid = $productAvailability.data('uuid'),
            ats = $productAvailability.data('ats'),
            message = $productAvailability.data('message'),
            availableInStores = $productAvailability.data('availableInStores');

        if ($productAvailabilityError.length && uuid && ats > 0) {
            const $spinButton = $(`.js-line-item-qty[data-uuid="${uuid}"]`);
            $spinButton.addClass('js-not-update-availability');

            if ($spinButton[0].spinbutton) {
                $spinButton[0].spinbutton.valuenow = ats;
                $spinButton[0].spinbutton.update();
            }

            $body.trigger('basket:notify', message);
        }

        if ($productAvailabilityError.length && ats === 0 && availableInStores ) {
            $productAvailability
                .closest('.js-product-info')
                .find('.js-product-pickup-details')
                .removeClass('h-hidden');
            $(`.js-availability-short-${uuid}`).empty();
        }
    });
}

module.exports = function () {
    checkAvailability();

    var isSpinUpdate = false;

    document.body.addEventListener('spinbutton:change', function (event) {
        const $cartError = $('.js-cart-error');
        const $input = $(event.target);
        const quantity = $input.val();
        const productID = $input.data('pid');

        let url = $input.data('action');
        const uuid = $input.data('uuid');
        const urlParams = {
            pid: productID,
            quantity,
            uuid
        };
        url = appendToUrl(url, urlParams);

        if ($input[0].spinbutton) {
            $input[0].spinbutton.toggleBusy(true);
        }
        $.spinner().start();
        $cartError.empty();

        const message = $(event.target).data('action-message');
        const messageError = $('.js-cart-content').data('action-message-cancel');

        $.ajax({
            url,
            type: 'get',
            context: this,
            dataType: 'json'
        })
            .done((data) => {
                const $spinButton = $(`.js-line-item-qty[data-uuid="${uuid}"]`);

                //Hiding availability error
                toggleAvailabilityError(event.target, false);

                if ($spinButton[0].spinbutton) {
                    $spinButton[0].spinbutton.update();
                    if (data.partiallyUpdatedQuantity) {
                        isSpinUpdate = true;
                        $($spinButton[0]).attr('aria-valuemax', data.partiallyUpdatedQuantity);
                    }
                    $spinButton[0].spinbutton.valuenow = data.partiallyUpdatedQuantity ? data.partiallyUpdatedQuantity : quantity;
                } else {
                    $spinButton.val(quantity);
                }

                const productsData = JSON.parse($('.js-product-in-basket').attr('data-product'));
                productsData.forEach((productData) => {
                    if (String(productData.variationId) === String(productID) || String(productData.id) === String(productID)) {
                        productData.quantity = Number(quantity);
                        $('.js-product-in-basket').attr('data-product', JSON.stringify(productsData));
                    }
                });

                if ($('.shipping-section').length) {
                    // Applies to Checkout - Shipping - change product qty
                    $('body')
                        .trigger('basket:update:bonus:products', data)
                        .trigger('basket:update:totals', data)
                        .trigger('basket:update:promos', data.totals.discountsHtml)
                        .trigger('cart:update')
                        .trigger('checkout:updateCheckoutView', {order: data});

                    var $invalidFeedbackMessage = $($spinButton[0])
                        .closest('.b-product_line_item-details_item')
                        .siblings('.invalid-feedback');

                    if ($invalidFeedbackMessage.attr('data-max-check') === 'true') {
                        $invalidFeedbackMessage.attr('data-max-check', 'false');
                    } else {
                        $invalidFeedbackMessage.toggleClass('d-none', !(data.partiallyUpdatedQuantity || isSpinUpdate));
                    }

                    var $availabilityMessageObject = $(`.js-max-availability-message-${uuid}:visible`);
                    if ($($spinButton[0]).val() === $($spinButton[0]).attr('aria-valuemax')) {
                        var maxMessage = $availabilityMessageObject.attr('data-max-message').replace('MAX_QUANTITY', $($spinButton[0]).attr('aria-valuemax'));
                        $availabilityMessageObject.find('.js-max-availability-message-text').html(maxMessage);
                    } else {
                        $availabilityMessageObject.find('.js-max-availability-message-text').html('');
                    }

                } else {
                    $('body')
                        .trigger('basket:update:bonus:products', data)
                        .trigger('basket:update:totals', data)
                        .trigger('basket:update:discounts', {discounts: data.approachingDiscounts})
                        .trigger('basket:update:promos', data.totals.discountsHtml)
                        .trigger('basket:validate', data)
                        .trigger('minicart:update:content', data)
                        .trigger('cart:update');

                    if (!$spinButton.hasClass('js-not-update-availability')) {
                        $('body').trigger('basket:update:availability', {data, uuid});
                    } else {
                        $spinButton.removeClass('js-not-update-availability');
                    }
                }

                $input.focus();
                if (!data.partiallyUpdatedQuantity && isSpinUpdate) {
                    isSpinUpdate = false;
                } else {
                    waiNotify(message);
                }
            })
            .fail((err) => {
                if (err.responseJSON.redirectUrl) {
                    window.window.location.href = err.responseJSON.redirectUrl;
                } else {
                    const data = err.responseJSON;
                    const uuid = err.responseJSON.items[0].UUID;

                    err.responseJSON.isShowButton = true;

                    $('body')
                        .trigger('basket:validate', err.responseJSON)
                        .trigger('basket:update:availability', {data, uuid});

                    const $spinButton = $(`.js-line-item-qty[data-uuid="${uuid}"]`);
                    $($spinButton[0])
                        .closest('.b-product_line_item-details_item')
                        .siblings('.invalid-feedback')
                        .removeClass('d-none');

                    if (messageError) {
                        waiNotify(messageError);
                    }
                }
            })
            .always(() => {
                $.spinner().stop();
                if ($input[0].spinbutton) {
                    $input[0].spinbutton.toggleBusy(false);
                }
            });
    });

    document.body.addEventListener('spinbutton:warn', (event) => {
        if (event.detail.currentValue >= event.detail.maxValue) {
            toggleAvailabilityError(event.target, true);
        }
    });
};
